// extracted by mini-css-extract-plugin
module.exports = {"logo":"ShopLogo-logo-1098","compact":"ShopLogo-compact-1098"};